module.exports = __webpack_public_path__ + "fonts/Gotham-Bold.722c5f89.otf";